import styled from "styled-components";

import { Link, Logo } from "@vinomofo/components";

export interface FooterLogoProps {
  height?: string;
}

const LogoLink = styled(Link)<FooterLogoProps>`
  height: ${({ height }) => height};
  display: block;
  margin-right: 16px;

  svg {
    width: auto;
    height: inherit;
    vertical-align: middle;
  }
`;

export const FooterLogo = ({ height }: FooterLogoProps): JSX.Element => {
  return (
    <LogoLink href="/" height={height}>
      <Logo />
    </LogoLink>
  );
};

FooterLogo.defaultProps = {
  height: "24px",
};
